import relatedDomainsDictionary from './relatedDomainsDictionary.json';

export type RelatedDomainsDictionary = Record<string, string[] | undefined>;

export default function getRelatedDomains(domain: string): string[] | undefined {
  const relatedDomains = getRelatedDomainsDictionary()[domain];
  return relatedDomains;
}

function getRelatedDomainsDictionary() {
  return relatedDomainsDictionary as RelatedDomainsDictionary;
}
